import React, { useState } from "react";
import "./PaymentIframePage.css";
import { useIframeState } from "../../scheduler/hooks/useIframeState";
import { useFormContext } from "../../../common/contexts/FormContext";
import { Step } from "../../../Interface/scheduler/form";
import { CircularProgress } from "@mui/material";

interface PaymentIframePageProps {
  config: Step;
}

const PaymentIframePage: React.FC<PaymentIframePageProps> = ({ config }) => {
  const { formValues } = useFormContext();
  const { iframeRef, handleIframeLoad } = useIframeState();
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const preAuthConfig = config?.preAuthAmount;
  const iframeUrl =
    formValues?.jkcode && `${config?.paymentUrl}?jkno=${formValues.jkcode}`;

  const { preauthorizationAmount, preauthorizationEnabled } = formValues;

  let disclaimerText = "";
  if (preauthorizationEnabled) {
    disclaimerText = preAuthConfig?.disclaimer?.replace(
      "{fee}",
      preauthorizationAmount
    );
  } else {
    disclaimerText = preAuthConfig?.defaultDisclaimer;
  }

  const handleIframeLoadComplete = () => {
    setIsIframeLoading(false);
    handleIframeLoad();
  };

  const handleIframeError = () => {
    console.error("Iframe failed to load");
    setIsIframeLoading(false);
  };
  return (
    <div className="payment-iframe-container">
      <div className="payment-iframe-wrapper">
        {isIframeLoading && (
          <div className="loader-wrapper">
            <CircularProgress />
          </div>
        )}
        <iframe
          className={`payment-iframe ${isIframeLoading ? "loading" : "loaded"}`}
          title="Payment Iframe"
          id="customer-payment-iframe"
          src={iframeUrl}
          onLoad={handleIframeLoadComplete}
          onError={handleIframeError}
          data-testid="payment-iframe"
          ref={iframeRef}
        />
      </div>
      <div className="payment-disclaimer" data-testid="payment-disclaimer">
        <span className="payment-disclaimer-text">{disclaimerText}</span>
      </div>
    </div>
  );
};

export default PaymentIframePage;
